import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { ButtonNames } from '../../../../../../contexts/main/biInterfaces';
import { isUserCompleted } from '../../../../../../contexts/User/helpers/userTypeHandlers';
import { SidebarControlsContainer } from '../../../components/SidebarControlsContainer/SidebarControlsContainer';
import { StartButton } from './StartButton';
import { Props } from '../interfaces';

export interface OverviewControlsProps {
  props: Props;
  currentStep: ParticipantStep | null;
  isProgramFinished: boolean;
  getQuizData: () => any;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep, preventScrolling?: boolean) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
  scrollToContent: () => void;
}

export const OverviewControls: React.FC<OverviewControlsProps> = ({
  props,
  currentStep,
  isProgramFinished,
  getQuizData,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
  scrollToContent,
}) => {
  const {
    userType,
    isParticipantInSuspendedState,
    isParticipantInLockedState,
  } = props;
  const isStepActive = !!currentStep?.id;
  const isOverviewActive = !isStepActive;
  const isCompletedChallenge = isUserCompleted(userType) || isProgramFinished;
  const isParticipantInNegativeState =
    isParticipantInSuspendedState || isParticipantInLockedState;
  const { isQuiz } = getQuizData();

  const shouldShowOverviewControls =
    isOverviewActive &&
    !isCompletedChallenge &&
    !isParticipantInNegativeState &&
    !isQuiz;

  if (!shouldShowOverviewControls) {
    return null;
  }

  return (
    <SidebarControlsContainer>
      <StartButton
        props={props}
        getIsStartDisabled={getIsStartDisabled}
        setStep={setStep}
        sendBiButtonClick={sendBiButtonClick}
        scrollToContent={scrollToContent}
      />
    </SidebarControlsContainer>
  );
};
